import type { MarqueeTeamStatus } from '@/features/marquee/types'
import { teamStatusToLabelKey } from '@/features/marquee/utils'
import { cn } from '@/helpers/utils'
import { useTranslation } from '@/translations/i18n'

const STATUS_STYLES = {
	active: 'bg-green-200 text-green-700',
	invited: 'bg-red-100 text-orange-700',
	invite_expired: 'bg-red-100 text-red-800',
	deactivated: 'bg-grey-200 text-grey-1000'
} as const satisfies Record<MarqueeTeamStatus, string>

interface TeamMemberStatusBadgeProps {
	status: MarqueeTeamStatus
	className?: string
}

/** The Team table's status pill, same shape as the event status badge. */
export function TeamMemberStatusBadge({
	status,
	className
}: TeamMemberStatusBadgeProps) {
	const { t } = useTranslation()
	return (
		<span
			className={cn(
				'inline-flex items-center whitespace-nowrap rounded-full px-3 py-1.5 font-medium text-xs',
				STATUS_STYLES[status],
				className
			)}
		>
			{t(teamStatusToLabelKey[status])}
		</span>
	)
}
